import { useEffect, useMemo } from "react";
import { getNativePlatform, getNativePushToken, type NativePlatform } from "@/lib/native";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/hooks/use-auth";

export function useNativePlatform(): { platform: NativePlatform; isNative: boolean } {
  const platform = useMemo(getNativePlatform, []);
  return { platform, isNative: platform !== "web" };
}

/** Mount once: marks <html> for native styling and saves the push token for the signed-in user. */
export function NativeBootstrap() {
  const { platform, isNative } = useNativePlatform();
  const { user } = useAuth();

  useEffect(() => {
    document.documentElement.dataset.platform = platform;
  }, [platform]);

  useEffect(() => {
    if (!isNative || !user) return;
    const token = getNativePushToken();
    if (!token) return;
    supabase
      .from("push_tokens")
      .upsert({ user_id: user.id, token, platform, updated_at: new Date().toISOString() }, { onConflict: "user_id,token" })
      .then(({ error }) => error && console.warn("push token save failed"));
    // Keep store entitlements fresh on app open.
    supabase.functions.invoke("sync-subscription").catch(() => undefined);
  }, [isNative, user, platform]);

  return null;
}
